import {
  ChevronRight as ChevronRightIcon,
  FolderOpen as FolderOpenIcon,
} from '@rossum/ui/icons';
import { Box, Stack, Typography } from '@rossum/ui/material';

type WorkspaceQueueBreadcrumbsProps = {
  workspace?: string;
  queue?: string;
};
export const WorkspaceQueueBreadcrumbs = ({
  workspace,
  queue,
}: WorkspaceQueueBreadcrumbsProps) => (
  <Stack
    alignItems="center"
    direction="row"
    spacing={1}
    sx={{ pr: 1, minWidth: 0 }}
  >
    <FolderOpenIcon sx={{ fontSize: 32, color: 'primary.main' }} />
    <Stack
      direction="row"
      spacing={3}
      alignItems="center"
      minHeight={36}
      sx={{ minWidth: 0 }}
    >
      <Typography
        variant="h5"
        data-cy="wq-breadcrumbs-text"
        fontWeight={600}
        sx={{ minWidth: 0 }}
      >
        <Stack
          direction="row"
          alignItems="center"
          divider={
            <ChevronRightIcon
              sx={{
                fontSize: 22,
                mx: 0.5,
                color: theme => theme.palette.text.primary,
              }}
            />
          }
        >
          {workspace && (
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: theme => theme.palette.text.primary,
              }}
            >
              {workspace}
            </Box>
          )}
          {queue && (
            <Box
              sx={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                color: theme => theme.palette.text.primary,
              }}
            >
              {queue}
            </Box>
          )}
        </Stack>
      </Typography>
    </Stack>
  </Stack>
);
